import * as React from 'react';
export const IcStreamOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.65 15.11A7.88 7.88 0 014 12a8 8 0 013.56-6.61 1.001 1.001 0 10-1.12-1.66 9.89 9.89 0 00-3.29 12.88l1.5-1.5zM6 12a6.16 6.16 0 00.21 1.55L8 11.73a4 4 0 011.6-2.91 1 1 0 10-1.2-1.6A5.93 5.93 0 006 12zm13.71-6.3l1-1a1.004 1.004 0 10-1.42-1.42l-6.78 6.78A2.089 2.089 0 0012 10a2 2 0 00-2 2c.002.172.026.344.07.51l-6.78 6.78a1 1 0 000 1.42.998.998 0 001.42 0l1-1c.24.2.48.38.74.56a1 1 0 00.56.17.998.998 0 00.973-1.191 1 1 0 00-.423-.64 4.45 4.45 0 01-.43-.33l1.42-1.42c.138.08.292.128.45.14a1 1 0 00.8-.4 1 1 0 00.08-1l1.61-1.6c.17.022.34.022.51 0a2 2 0 002-2 2.087 2.087 0 00-.07-.51L15.42 10a3.86 3.86 0 01.58 2 3.93 3.93 0 01-1.6 3.18 1 1 0 001.2 1.6A5.929 5.929 0 0018 12a5.86 5.86 0 00-1.12-3.46l1.41-1.41A7.85 7.85 0 0120 12a8 8 0 01-3.56 6.61 1.001 1.001 0 101.12 1.66A10 10 0 0022 12a9.85 9.85 0 00-2.29-6.3z'
      fill='currentColor'
    />
  </svg>
);
